export class ReponseBase<T> {

    valeur: T;
    estUnSucces: boolean;
    messages: Message[] = [];

    constructor() {
    }

}


export class Message {
    type: TypeEvenement;
    code: string;
    description: string;

    constructor();
    constructor(type: TypeEvenement, description: string, code?: string);
    constructor(type?: TypeEvenement, description?: string, code: string = '') {
        if (type !== undefined && description !== undefined) {
            this.type = type;
            this.code = code;
            this.description = description;

            if (!code) {
                this.code = this.severity;
            }
        }
    }

    get severity(): string {
        switch (this.type) {
            case TypeEvenement.Erreur:
                return 'error';
            case TypeEvenement.Avertissement:
                return 'warn';
            case TypeEvenement.Information:
                return 'info';
            default:
                return 'info';
        }
    }

    get typeString(): string {
        return TypeEvenement[this.type] || 'Information';
    }
}

export enum TypeEvenement
{
    Erreur = 0,
    Avertissement = 1,
    Information = 2
}

export function MessagesToToastObject(messages: Message[] | Message): any[] {
    if ((messages as any).type !== undefined) {
        return [{ severity: (messages as any).severity, summary: (messages as any).typeString, detail: (messages as any).description }];
    }
    return (messages as any[]).map(message => ({ severity: message.severity, summary: message.typeString, detail: message.description }));
}